import useOnClickOutside from '@/hooks/useOnClickOutside'
import { SidebarType } from '@/types/shared'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { Collapse, MenuItem, Typogaphy } from 'vnetwork-ui'

interface ItemProps {
    item: SidebarType
}

const Item: React.FC<ItemProps> = ({ item }) => {
    const [showChildren, setShowChildren] = useState(false)
    const { t } = useTranslation()

    const childrenRef = useRef<HTMLDivElement | null>(null)

    const navigate = useNavigate()
    const { pathname } = useLocation()

    const handleClickMenu = (item: SidebarType) => {
        if (item?.children && item?.children?.length > 0) {
            setShowChildren(!showChildren)
        } else {
            navigate(item?.path, { replace: true })
        }
    }

    useOnClickOutside(childrenRef, () => {
        setShowChildren(false)
    })

    useEffect(() => {
        setShowChildren(false)
    }, [pathname])

    return (
        <div ref={childrenRef}>
            <div
                onClick={() => handleClickMenu(item)}
                className={`p-2 flex flex-col items-center cursor-pointer ${
                    pathname === item?.path ? 'bg-info' : ''
                }`}
            >
                <div className="w-6 h-6">{item?.icon}</div>
                <Typogaphy className="mt-2 text-xxs">
                    {t(item?.title)}
                </Typogaphy>
            </div>

            <Collapse
                open={Boolean(
                    item?.children && item?.children?.length > 0 && showChildren
                )}
                className="fixed z-[9999] md:left-auto md:right-auto left-0 right-0 min-w-[200px] bottom-[60.5px] md:bottom-auto rounded-[8px] bg-white shadow-md"
            >
                {item?.children?.map((child) => (
                    <MenuItem
                        color="info"
                        key={child?.path}
                        value={child?.path}
                        children={t(child?.title)}
                        icon={child?.icon}
                        selected={pathname === child?.path}
                        className={`rounded-[8px] pl-10 md:justify-start justify-center`}
                        onClick={() => navigate(child?.path, { replace: true })}
                    />
                ))}
            </Collapse>
        </div>
    )
}

export default Item
